import React, { useMemo } from 'react';
import { TreeSelect } from 'antd';
import type { TreeSelectProps } from 'antd';
import { buildCbsTreeData, buildWbsTreeData, type Est3WbsNode } from '@/utils/est3WbsTree';

export interface EpcEstimateWbsTreeSelectProps extends Omit<TreeSelectProps, 'treeData'> {
  nodes: Est3WbsNode[];
  kind?: 'wbs' | 'cbs';
}

export const EpcEstimateWbsTreeSelect: React.FC<EpcEstimateWbsTreeSelectProps> = ({
  nodes,
  kind = 'wbs',
  placeholder = 'Select WBS',
  ...rest
}) => {
  const treeData = useMemo(() => {
    if (kind === 'cbs') {
      return buildCbsTreeData(nodes as Array<{ id: string; code: string; name?: string; parent_id?: string | null }>);
    }
    return buildWbsTreeData(nodes);
  }, [nodes, kind]);

  return (
    <TreeSelect
      showSearch
      allowClear
      treeDefaultExpandAll
      treeNodeFilterProp="title"
      placeholder={kind === 'cbs' ? 'Select CBS' : placeholder}
      treeData={treeData}
      style={{ width: '100%' }}
      {...rest}
    />
  );
};
